module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"open":"Öffnen"},"en":{"open":"Open"}}')
  delete Component.options._Ctor
}
